import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { ActiveIngredientModel } from "../models";

class ActiveIngredientService {
	constructor() {
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Pragma: 'no-cache'
		}
	}

	getActiveIngredient(id: number, lang: string) {
		return axios({
			url: `${Constants.apiUrl}/activeIngredient/getById/${id}`,
			method: 'get',
			headers: {
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

}

export default ActiveIngredientService;
